function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_798",
  "data-name": "Grupo 798",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_542",
  "data-name": "Grupo 542",
  transform: "translate(1.41)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_859",
  "data-name": "Caminho 859",
  d: "M310.145,89.593h-.868c0-.015,0-1.489.1-2.81a4.385,4.385,0,0,1,4.483-3.984,4.274,4.274,0,0,1,4.485,4.015v2.6h-.868v-2.6a3.425,3.425,0,0,0-3.616-3.184,3.537,3.537,0,0,0-3.616,3.214C310.146,88.134,310.145,89.578,310.145,89.593Z",
  transform: "translate(-309.276 -82.799)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_543",
  "data-name": "Grupo 543",
  transform: "translate(0 6.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_860",
  "data-name": "Caminho 860",
  d: "M318.735,98.822h-9.72a1.064,1.064,0,0,1-1.085-1.039V90.323a1.065,1.065,0,0,1,1.085-1.04h9.72a1.065,1.065,0,0,1,1.086,1.04v7.461A1.065,1.065,0,0,1,318.735,98.822Zm-9.72-8.707a.213.213,0,0,0-.217.208v7.461a.213.213,0,0,0,.217.208h9.72a.213.213,0,0,0,.217-.208V90.323a.213.213,0,0,0-.217-.208Z",
  transform: "translate(-307.93 -89.283)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_544",
  "data-name": "Grupo 544",
  transform: "translate(3.941 9.198)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_861",
  "data-name": "Caminho 861",
  d: "M313.665,95.75a1.889,1.889,0,1,1,1.972-1.888A1.933,1.933,0,0,1,313.665,95.75Zm0-2.944a1.057,1.057,0,1,0,1.1,1.057A1.083,1.083,0,0,0,313.665,92.806Z",
  transform: "translate(-311.692 -91.975)"
})));

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.892,
    height: 16.039,
    viewBox: "0 0 11.892 16.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.2d7fe49f.svg";
export { ForwardRef as ReactComponent };